import { render } from "./visibility-setting.vue?vue&type=template&id=2065a64f&scoped=true"
import script from "./visibility-setting.vue?vue&type=script&lang=js"
export * from "./visibility-setting.vue?vue&type=script&lang=js"

import "./visibility-setting.vue?vue&type=style&index=0&id=2065a64f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2065a64f"]])

export default __exports__